import Utils from "./Utils";

let after_hooks = {}, before_hooks = {};

class View{
    constructor( selector ){
        this.selector = selector;
        this.$el = $( selector ).first();
        this.el = this.$el.get( 0 );
    }

    $( selector ){
        return this.$el.find( selector );
    }

    render( RenderPromise ){
        RenderPromise.resolve();
    }
}


View.create = function( ViewClass, selector ){
    let ViewObject = new ViewClass( selector );

    return ViewObject;
}

View.addHook = function( name, callback, priority, after = false ){
    let hooks_obj = after ? after_hooks : before_hooks;
    if( hooks_obj[ name ] === undefined ) hooks_obj[ name ] = [];

    if( typeof callback !== "function" ) throw "Hooks only accept function as second argument.";

    callback.__priority = priority === undefined ? 50 : priority;

    hooks_obj[ name ].push( callback );;

    Utils.sortOnKey( hooks_obj [name ], '__priority' );
};

View.do = function( name, ViewObject, ...args ){
    function callHooks( hooks ){
        if(hooks[ name ]){
            for( let i = 0; i < hooks[ name ].length; i++ ){
                hooks[ name ][ i ].call( window, ViewObject );
            }
        }
    }

    callHooks( after_hooks );

    if( typeof ViewObject[ name ] == 'function' ){
        ViewObject[ name ]( ...args );
    }

    callHooks( before_hooks );
}


export default View;



// WEBPACK FOOTER //
// ./resources/assets/js/framework/View.js